var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-loading-wrapper for-uploading"},[_c('div',{staticClass:"custom-loading"},[_c('div',{staticClass:"rect1"}),_c('div',{staticClass:"rect2"}),_c('div',{staticClass:"rect3"}),_c('div',{staticClass:"rect4"}),_c('div',{staticClass:"rect5"})]),_c('p',[_vm._v("Uploading please wait...")])])
}]

export { render, staticRenderFns }